export default __webpack_public_path__ + "static/media/SFMarketing@2x.97637c60.png";